import * as React from 'react';
import classNames from 'classnames';

import ThemeDefinition from '../../domain/ThemeDefinition';

import styles from './Dialog.module.css';

interface IProps {
  className?: string;
}

class Dialog extends React.Component<IProps> {
  render() {
    const { className, children } = this.props;

    return <div className={classNames(styles.dialog, ThemeDefinition.dialog.root, className)}>{children}</div>;
  }
}

class DialogContent extends React.Component<IProps> {
  render() {
    const { className, children } = this.props;

    return <div className={classNames(styles.content, ThemeDefinition.dialog.content, className)}>{children}</div>;
  }
}

class DialogControls extends React.Component<IProps> {
  render() {
    const { className, children } = this.props;

    return <div className={classNames(styles.controls, ThemeDefinition.dialog.controls, className)}>{children}</div>;
  }
}

export { DialogContent, DialogControls };
export default Dialog;
